import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import React, { useEffect, useState } from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { Stop } from '../../domain/stop/Stop';

import _ from 'lodash';
import { clientService } from '../../application/ClientService';
import { useRetrieveActiveProject } from '../../hooks/project/useRetrieveActiveProject';
import FormattedMessage from '../../react-components/FormattedCustomMessage';
import Text from '../../react-components/Text';
import { AsyncSearchCustomOption, AsyncSearchNoOptionsMessage } from './AsyncSearchComponents';

type FormPickupProps = {
  label: string | React.ReactElement;
  fieldValue?: Stop;
  onChange: (...args: any[]) => any;
  placeholder: string | React.ReactElement;
};

export const FormPickup = ({ label, fieldValue, onChange, placeholder }: FormPickupProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const [value, setValue] = useState<Stop | undefined>(undefined);
  const isSearchable = () => !fieldValue;

  useEffect(() => {
    setValue(fieldValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldValue]);

  const _loadSuggestions = (inputValue: string, callback: (options: any) => void) => {
    clientService
      .searchClients({
        project: activeProject!,
        offset: 0,
        limit: 5,
        searchText: inputValue,
      })
      .then((resp) => callback(resp.docs));
  };

  const loadSuggestions = _.debounce(_loadSuggestions, 300);

  const colourStyles = {
    control: (styles: any, state: any) => ({
      ...styles,
      borderColor: `${
        state.isFocused || state.isSelected ? RoutalPalette.primary00 : RoutalPalette.neutral20
      } !important`,
      backgroundColor: `transparent`,
      fontSize: `13px`,
      boxShadow: state.isFocused ? 0 : 0,
      '&:hover': {},
    }),
  };

  return (
    <>
      {label && <Text variant="label">{label}</Text>}
      <VSpacer small />
      <AsyncCreatableSelect
        placeholder={placeholder}
        value={value}
        cacheOptions
        isClearable
        isSearchable={isSearchable()}
        components={{
          Option: AsyncSearchCustomOption,
          NoOptionsMessage: (_props: any) => (
            <AsyncSearchNoOptionsMessage
              noOptionsMessage={<FormattedMessage id="properties.service.pickup.no_options" />}
            />
          ),
        }}
        onChange={onChange}
        formatCreateLabel={(inputValue: any) => {
          return <FormattedMessage id="properties.service.pickup.create_new" values={{ value: inputValue }} />;
        }}
        styles={colourStyles}
        loadOptions={loadSuggestions}
      />
    </>
  );
};
